<template>
    <div id="app" :class="className">
        <div v-if="envName != 'app'" class="env-name">
            <span class="name">{{ envName }}</span>
        </div>
        <router-view />
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'App',
    components: {},
    computed: {
        ...mapState({
            vuexCompany: (state) => state.account.company,
            vuexToken: (state) => state.account.token,
        }),
        envName() {
            return process.env.VUE_APP_ENV_NAME;
        },
        className() {
            return `env-${this.envName}`;
        },
    },
    mounted() {
        console.log(process.env.VUE_APP_VERSION);

        window.addEventListener('focus', () => {
            if (!localStorage.getItem('token') && this.vuexToken) {
                this.$msgbox({
                    title: '',
                    message: '您已在其他分頁中登出。',
                    confirmButtonText: '我瞭解了',
                    closeOnClickModal: false,
                    beforeClose: () => {
                        window.location.href = `${window.location.origin}/login`;
                    },
                });
                return;
            }
            if (localStorage.getItem('token') && !this.vuexToken) {
                this.$msgbox({
                    title: '',
                    message: '您已在其他分頁中登入。',
                    confirmButtonText: '我瞭解了',
                    closeOnClickModal: false,
                    beforeClose: this.goToHome,
                });
                return;
            }

            if (localStorage.getItem('token') && this.vuexCompany === localStorage.getItem('company') && localStorage.getItem('token') !== this.vuexToken) {
                this.$msgbox({
                    title: '',
                    message: '您已用其他身份登入或是重複登入。',
                    confirmButtonText: '我瞭解了',
                    closeOnClickModal: false,
                    beforeClose: this.goToHome,
                });
                return;
            }

            if (!(localStorage.getItem('company') && this.vuexCompany)) return;

            if (this.vuexCompany !== localStorage.getItem('company')) {
                this.$msgbox({
                    title: '',
                    message: '您已登入其他公司，請重新整理！',
                    confirmButtonText: '我瞭解了',
                    closeOnClickModal: false,
                    beforeClose: this.goToHome,
                });
            }
        });
    },
    methods: {
        goToHome() {
            const COMPANY_NAME = localStorage.getItem('company');
            window.location.href = `${window.location.origin}/${COMPANY_NAME}/index`;
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
@import "@/assets/scss/icomoon-style.scss";
@media print {
    ::-webkit-scrollbar {
        display: none;
    }
    .pagebreak {
        page-break-inside: avoid;
        page-break-before: always;
    }
    .el-message {
        display: none !important;
    }
}
#app {
    .env-name {
        position: fixed;
        top: 0;
        left: 0;
        text-transform: uppercase;
        z-index: 99999;
        font-size: 8pt;
        font-weight: bold;
        color: #fff;
        padding: 0 10px;
        border-bottom-right-radius: 5px;

        &:before {
            content: "";
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 3px;
            background-color: #000;
        }

        @media print {
            display: none;
        }
    }

    &.env-dev {
        .env-name {
            background-color: #000;
            &:before {
                background-color: #000;
            }
        }
    }
    &.env-stage {
        .env-name {
            background-color: rgb(0, 152, 43);
            &:before {
                background-color: rgb(0, 152, 43);
            }
        }
    }
}
</style>
